const FIXED_CODE = /^[A-Za-z0-9_]{1,64}$/;

/** The code of `error_shown`: a fixed code of the server, never the text of an error. */
export function errorCodeOf(error: unknown): string {
  if (typeof error !== 'object' || error === null || !('data' in error)) {
    return 'unknown';
  }
  const data = error.data as { errorType?: unknown; code?: unknown } | null;
  const code = data?.errorType ?? data?.code;
  return typeof code === 'string' && FIXED_CODE.test(code) ? code : 'unknown';
}
